import translationPL from "./localization/pl.json";
import translationEN from "./localization/en.json";

export const language = process.env.GATSBY_LANGUAGE || "pl";

export const isPL = language === "pl";
export const OWN_ORIGIN = isPL ? "https://opcjanatura.pl" : "https://option-nature.com";
export const isEN = language === "en";
export const isCartEnabled = isPL;
export const brandName = isPL ? "Opcja Natura" : "Option Nature";

export const translate = (key: string): string => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const resp = isPL ? (translationPL[key] as string) : (translationEN[key] as string);
  return resp;
};
